/** Display only; selection and recipient verification keep the authoritative phone. */
export function maskPhoneNumber(value?: string): string {
  const digits = Array.from(value || "").filter(character => /\p{Nd}/u.test(character)).join("");
  if (!digits) return "—";
  if (digits.length <= 5) return "*".repeat(digits.length);
  return `${value?.trim().startsWith("+") ? "+" : ""}${digits.slice(0, 3)}${"*".repeat(digits.length - 5)}${digits.slice(-2)}`;
}
